import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser, enumParser, loginTypeParser, PartnerOrganizationMemberRole, PartnerOrganizationType, userStatusParser, } from '#validation';
export const UserResponseSchema = z.object({
    id: z.string(),
    accountId: z.string(),
    email: z.email(),
    emailVerified: z.boolean(),
    firstName: z.string(),
    lastName: z.string(),
    status: userStatusParser,
    loginType: loginTypeParser.nullish(),
    hasCompletedMfa: z.boolean().nullish(),
    hasSetupMfa: z.boolean().nullish(),
    hasPassword: z.boolean().nullish(),
    backupCodeInfo: z
        .object({
        isSet: z.boolean(),
        createdAt: dateParser().optional(),
    })
        .nullish(),
    pendingInvitation: z
        .object({
        invitationId: z.string(),
        eLinkSecretByUserKey: z.string(),
    })
        .nullish(),
    partnerOrganizations: z
        .array(z.object({
        id: z.string(),
        name: z.string(),
        type: enumParser(PartnerOrganizationType),
        role: enumParser(PartnerOrganizationMemberRole),
    }))
        .optional(),
    createdAt: dateParser(),
    updatedAt: dateParser(),
});
export class UserResponseDto extends createZodDto(UserResponseSchema) {
}
